import { render } from "./OrderItemsSearchComponent.vue?vue&type=template&id=6caaf154&ts=true"
import script from "./OrderItemsSearchComponent.vue?vue&type=script&lang=ts"
export * from "./OrderItemsSearchComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__